module.exports = __webpack_public_path__ + "img/DSC_0794.95f52f65.jpeg";